module.exports = __webpack_public_path__ + "img/partnership_plan_subtitle.0b78a726.png";